import { Pill, StatusEffect } from './status';
import { range } from '../util/number';

export type Schedule = TimeSlot[];

export type PillSchedule = Record<TimeSlot['time'], Pill[]>;

export enum Modifier {
    isNight,
    isMealtime,
    isGone,
}

export type TimeSlot = {
    time: number;
    modifiers: Modifier[];
    effects: StatusEffect[];
}

export type TimeSlotDefinition = {
    from: number;
    to?: number;
    modifiers: Modifier[];
    effects: StatusEffect[];
}


export const createSchedule = (schedule: TimeSlotDefinition[]): Schedule => {
    const slots: TimeSlot[] = range(6).map((_, i) => ({
        time: i,
        modifiers: [],
        effects: [],
    }));

    for (let i = 0; i < schedule.length; i++) {
        for (let j = schedule[i].from; j < (schedule[i].to ?? (schedule[i].from + 1)); j++) {
            const previous = slots[j];
            const modifiers = previous ? [ ...previous.modifiers, ...schedule[i].modifiers ] : schedule[i].modifiers;
            const effects = previous ? [ ...previous.effects, ...schedule[i].effects ] : schedule[i].effects;

            slots[j] = {
                time: j,
                modifiers,
                effects,
            };
        }
    }

    return slots;
};
